import { z } from 'zod'

// Focus-сессия «одна на сотрудника»: running (в фокусе) или stopped (вышел).
// Независима от pomodoro и трекинга времени — оркестрацию связывает фронт.
export const FocusStateSchema = z.enum(['running', 'stopped'])
export type FocusState = z.infer<typeof FocusStateSchema>

// Фокус = presence «не беспокоить», без привязки к задаче: просто «я сосредоточен».
export const FocusSessionSchema = z.object({
  id: z.string(),
  employeeId: z.string(),
  startedAt: z.string(),
  state: FocusStateSchema,
  createdAt: z.string(),
  updatedAt: z.string(),
})
export type FocusSession = z.infer<typeof FocusSessionSchema>
